<template>
    <div class="dialog-border" :style="'width:' + width + 'px'">
        <v-row class="no-frame ">
            <v-select
                v-if="items"
                v-model        = "selected"
                :label         = "itemLabel"
                :items         = "items"
                item-value     = "id"
                :item-text     = "itemText"
                :return-object = "true"
                :hide-details  = "true"
                class          = " pl-4 pr-5 mt-4"
                @change        = "onSelected"
            >
                <template v-slot:item="{ item }">
                    <slot name="item" v-bind:item="item" />
                </template>
                <template v-slot:selection="{ item }">
                    <slot name="selection" v-bind:item="item" />
                </template>
            </v-select>

            <div class="v-flex w-100 pl-4 pr-5">
                <v-text-field
                    v-model        = "searchtext"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    append-icon    = "fas fa-search"
                    @input         = "onSearch"
                    class          = "pb-1"
                    clearable
                    hide-details
                />
            </div>
        </v-row>

        <div class="mr-1 mb-2">
            <div style="max-height: 800px; overflow-y: scroll">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "PIncMailMenuContent",

    props: {
        width: {

        },

        items: {

        },

        itemText: {

        },

        itemLabel: {

        },

        selectedItem: {

        }
    },

    data: () => ({
        searchtext: null,
        selected: null,
    }),

    mounted() {
        this.selected = this.selectedItem;
    },

    watch: {
        selectedItem () {
            this.selected = this.selectedItem;
        }
    },

    methods: {
        onSearch () {
            this.$emit("search", this.searchtext);
        },

        onSelected () {
            console.log("onSelected", this.selected)
            this.$emit("selected", this.selected);
        }
    }
}
</script>

<style scoped>

</style>